<template>
  <div class="hooper-carousel">
    <Vue3Carousel
      :autoplay="5000"
      pause-autoplay-on-hover
      class="explanation-slider"
      :items-to-show="1"
      wrap-around
      snap-align="start"
      :breakpoints="breakpoints"
    >
      <Vue3Slide v-for="(item, index) in slides" :key="index">
        <template v-if="item">
          <div class="has-text-centered">
            <figure class="image">
              <ImageItem
                v-if="item.image"
                v-bind="item.image"
                :image-style="imageStyle"
                loading="lazy"
                class="image image-shadow"
              />
            </figure>
            <div
              class="mt-4 mb-4 is-size-small has-text-centered has-text-weight-semibold image-caption"
            >
              <span>{{ item.caption }}</span>
            </div>
          </div>
        </template>
      </Vue3Slide>
    </Vue3Carousel>
  </div>
</template>

<script setup lang="ts">
import type { ParagraphExplanationFragment } from '#graphql-operations'
import type { Breakpoints } from 'vue3-carousel'

defineProps<{
  slides: ParagraphExplanationFragment['keyImages']
}>()

const imageStyle = defineImageStyle({
  type: 'pictures',
  pictures: {
    xs: {
      aspectRatio: 730 / 486,
      width: 730,
      height: 486,
    },
  },
})

const breakpoints: Breakpoints = {
  990: {
    itemsToShow: 3,
    snapAlign: 'start',
  },
  768: {
    itemsToShow: 2,
    snapAlign: 'start',
  },
}
</script>

<style scoped lang="scss">
.explanation-slider {
  --vc-nav-color: #{$grey-light};
  --vc-nav-color-hover: #{$grey-dark};
  --vc-nav-width: 50px;
  --vc-nav-height: 50px;

  $gap: 30px;

  width: calc(100% + 2 * #{$gap});
  margin: -$gap;

  .carousel__slide {
    padding: 0 $gap;
  }
}

.hooper-carousel {
  $gap: 30px;

  .hooper {
    width: calc(100% + 2 * #{$gap});
    margin: -$gap;
    outline: none !important;
    height: auto !important;

    ::v-deep(.hooper-slide) {
      padding: 0 $gap;
      min-width: 200px;
    }
  }
}

.state {
  margin-top: 1.5rem;
}
</style>
